import { render, staticRenderFns } from "./PrintTaskList.vue?vue&type=template&id=f06c337e"
import script from "./PrintTaskList.vue?vue&type=script&lang=js"
export * from "./PrintTaskList.vue?vue&type=script&lang=js"
import style0 from "./PrintTaskList.vue?vue&type=style&index=0&id=f06c337e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports